// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"38ac69fb","239":"d8a32162","453":"2663791f","455":"c044bd20"}[chunkId] + ".chunk.js";
};